import { styled, useStyletron } from "baseui";
import { useState } from "react";
import { EmptyState } from "../../../../components/EmptyState";
import { TDailyScheduleEntry, TScheduler, TSpecialEvent } from "../types";
import ExceptionsList from "./ExceptionsList";
import { useIntl } from "react-intl";
import { GiClick } from "react-icons/gi";
import DayItem from "../WeeklySchedule/DayItem";
import AddEntryButton from "../AddEntryDialog/AddEntryButton";
import { getValueOptions } from "../utils";
import { IAddEventState } from "../AddEntryDialog";
import { TDailyScheduleEntryExtensions } from "../typeExtensions/TDailyScheduleEntryExtensions";



const ExceptionsView: React.FC<TScheduler & { hasChanges: boolean, items: TSpecialEvent[],
onAdd: (item: TSpecialEvent) => void,
onDelete: (item: TSpecialEvent) => void,
onUpdate: (item: TSpecialEvent) => void }> =
  (props) => {
    const { items, onAdd, onUpdate, onDelete } = props;
    const [css, theme] = useStyletron();
    const [selectedIndex, setSelectedIndex] = useState<number>(0);

    const intl = useIntl();

    const valueOptions = getValueOptions(props);

    const selectedItem = selectedIndex >= 0 ? items[selectedIndex] : undefined;
    
    const handleAddEvent = (args: IAddEventState) => {
      if (!selectedItem)
        return;
      const items = selectedItem?.entries ?? []
      const updated = TDailyScheduleEntryExtensions.addItem(items, { start: args.timeFrom, end: args.timeTo, value: args.value, isDefault: false, weekday: 1, id: `1_${items.length+1}`});
      selectedItem.entries = updated;
      onUpdate(selectedItem);
    }

    const handleEntryChanged = (weekday: number, item: TDailyScheduleEntry) => {
      if (!selectedItem)
        return;
      const items = selectedItem?.entries ?? []
      const updated = TDailyScheduleEntryExtensions.updateItem(items, item);
      selectedItem.entries = updated;
      onUpdate(selectedItem);
    }
    
    const handleEntryDeleted = (weekday: number, item: TDailyScheduleEntry) => {
      if (!selectedItem)
        return;
      const items = selectedItem?.entries ?? []
      const updated = TDailyScheduleEntryExtensions.deleteItem(items, item);
      selectedItem.entries = updated;
      onUpdate(selectedItem);
    }

    return (

      <MainContainer>
        <ExceptionsListContainer>
          <ExceptionsList onAddItem={onAdd} selected={selectedItem} app={props} items={items} onItemSelected={handleExceptionScheduleSelected} onDeleteItem={onDelete}></ExceptionsList>
        </ExceptionsListContainer>
        <SingleExceptionContainer>
          {selectedItem && <>
             Priority: {selectedItem.eventPriority}
            <DayItem onEntryChanged={handleEntryChanged} onEntryDeleted={handleEntryDeleted} now={new Date()} dayOfWeek={1} app={props} items={selectedItem?.entries ?? []}></DayItem>
            <div className={css({
              position: 'absolute',
              bottom: '-20px',
              right: '-20px',
              zIndex: 9999,
            })}>

              <AddEntryButton {...props} onAdd={handleAddEvent} showDays={false} valueOptions={valueOptions}></AddEntryButton>
            </div>
          </>}
          {!selectedItem &&
            <EmptyState
              icon={<GiClick></GiClick>}
              header={intl.formatMessage({ id: "noItemSelected", defaultMessage: "No item selected" })}
              message={intl.formatMessage({ id: "selectItemFromList", defaultMessage: "Select an item from the list" })}></EmptyState>
          }
        </SingleExceptionContainer>


      </MainContainer>
    )

    function handleExceptionScheduleSelected(item: any) {
      const index = items.findIndex(x => x === item);
      setSelectedIndex(index);
    }

  }

export default ExceptionsView;

const MainContainer = styled<'div', {}>("div", ({ $theme }) => ({
  width: '100%',
  //height: '100%',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  //overflowX: 'hidden',
  //overflowY: 'auto',
  gap: $theme.sizing.scale600
}));

const ExceptionsListContainer = styled<'div', {}>("div", ({ $theme }) => ({
  //width: 'auto',
  //height: 'auto',
}));

const SingleExceptionContainer = styled<'div', {}>("div", ({ $theme }) => ({
  position: 'relative',
  minWidth: '300px',
  //height: '100%',

}));